import { Directive, ElementRef, HostListener } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import moment from 'moment';

@Directive({
    selector: '[studyInlineEditorDatepickerValue]',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: StudyInlineEditorDatepickerValueDirective,
            multi: true
        }
    ]
})
export class StudyInlineEditorDatepickerValueDirective implements ControlValueAccessor {
    private onChange: (value: any) => void = () => {
    };
    private onTouched: () => void = () => {
    };

    constructor(private elementRef: ElementRef<HTMLInputElement>) {
    }

    // Called when value is written to the model
    writeValue(value: string): void {
        if (value) {
            // Convert YYYYMMDD to YYYY-MM-DD for the input element
            const year = value.substring(0, 4);
            const month = value.substring(4, 6);
            const day = value.substring(6, 8);
            const formattedDate = `${year}-${month}-${day}`;
            this.elementRef.nativeElement.value = formattedDate;
        } else {
            this.elementRef.nativeElement.value = '';
        }
    }

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    @HostListener('input', ['$event'])
    onInput(event: Event): void {
        const input = event.target as HTMLInputElement;
        const value = input.value;

        if (value) {
            // Convert YYYY-MM-DD to YYYYMMDD for the model
            const date = moment(value);
            if (date.isValid()) {
                const formattedDate = date.format('YYYYMMDD');
                this.onChange(formattedDate);
            } else {
                this.onChange('');
            }
        } else {
            this.onChange('');
        }
    }

    @HostListener('blur')
    onBlur(): void {
        this.onTouched();
    }

    setDisabledState(isDisabled: boolean): void {
        this.elementRef.nativeElement.disabled = isDisabled;
    }
}
